import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

export const STRIPE_URL = "https://buy.stripe.com/5kQ9AT8ob0Au0wReNH5os01";

/**
 * Big red direct-response CTA button used across the funnel.
 * Renders as an <a> that opens the Stripe checkout in a new tab.
 */
export default function CTAButton({
  children = "Get My Plan of Action — $197",
  subtext = null,
  testId,
  className = "",
  size = "lg",
}) {
  const padding =
    size === "lg" ? "px-5 sm:px-10 py-4 sm:py-6 text-base sm:text-xl" : "px-4 py-3 text-sm sm:text-base";

  return (
    <div className={`flex flex-col items-center ${className}`}>
      <motion.a
        href={STRIPE_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={testId}
        whileHover={{ y: -2, scale: 1.01 }}
        whileTap={{ scale: 0.98 }}
        transition={{ type: "spring", stiffness: 400, damping: 20 }}
        className={`group relative inline-flex items-center justify-center gap-2 sm:gap-3 ${padding} font-black tracking-tight bg-[#F04632] hover:bg-[#D93D2A] text-white rounded-xl pulse-glow uppercase text-center max-w-full`}
      >
        <span>{children}</span>
        <ArrowRight
          className="w-5 h-5 sm:w-6 sm:h-6 transition-transform duration-300 group-hover:translate-x-1"
          strokeWidth={3}
        />
      </motion.a>
      {subtext && (
        <p className="mt-3 text-xs sm:text-sm text-white/50 tracking-wide text-center max-w-md">
          {subtext}
        </p>
      )}
    </div>
  );
}
